import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { faArrowCircleLeft } from '@fortawesome/free-solid-svg-icons';
import * as markerjs2 from 'markerjs2';
import { first } from 'rxjs/operators';
import { LocalStorageService } from '../../local-storage.service';
import { CaptureImageData } from '../models/captureImage-model';
import { SharedDataService } from '../services/shared-data.service';
import { ToaterMessagesService } from '../services/toaster-messages.service';

@Component({
  selector: 'app-edit-img',
  templateUrl: './edit-img.component.html',
  styleUrls: ['./edit-img.component.scss'],
})
export class EditImgComponent implements OnInit {
  public reader = new FileReader();
  @ViewChild('img') img!: ElementRef;
  markerArea: any;
  public faArrowCircleLeft = faArrowCircleLeft;
  public sharedImage!: CaptureImageData;
  public indexedDBImages: any[] = [];
  public currentLang!: string;

  constructor(
    private router: Router,
    private shareDataService: SharedDataService,
    private localStorage: LocalStorageService,
    private toasterMessagesService: ToaterMessagesService
  ) {}

  ngOnInit(): void {
    this.refreshIndexedDBImg();

    this.localStorage.get('language', 'SwissTimeEntry', true).then((res: any) => {
      this.currentLang = res;
    });
    this.shareDataService.currentImage
      .pipe(first())
      .subscribe({ next: (res) => (this.sharedImage = res) });
    if (!this.sharedImage) this.router.navigate(['/timeapp']);

    setTimeout(() => {
      this.showMarkerArea();
    }, 100);
  }

  showMarkerArea() {
    if (this.img !== undefined) {
      this.markerArea = new markerjs2.MarkerArea(this.img?.nativeElement);
      markerjs2.Activator.addKey('MJS2-F045-M583-6415')	 
      this.markerArea.renderAtNaturalSize = true;
      this.markerArea.renderImageQuality = 1;
      this.markerArea.addEventListener('render', (event: any) => {
        this.img.nativeElement.src = event.dataUrl;

        this.sharedImage.data = this.img.nativeElement.src;

        const blob = this.dataURItoBlob(this.img.nativeElement.src);

        // create file from blob
        const file = new File([blob], this.sharedImage.blob.name, {
          type: 'image/png',
          lastModified: Date.now(),
        });

        this.sharedImage.blob = file;

        this.deleteAndSaveIntoIndexedDb(this.sharedImage);
        this.toasterMessagesService.toasterTranslateSuccessMessages(
          'Bild gespeichert',
          'Image enregistrée',
          this.currentLang
        );
        this.router.navigate(['/timeapp']);
      });

      this.markerArea.addEventListener('beforeclose', (event: any) => {
        // eslint-disable-next-line no-restricted-globals
        if (!confirm('Do you want to discard changes?')) {
          event.preventDefault();
        } else {
          this.router.navigate(['/timeapp']);
        }
      });
      this.markerArea.show();
    }
  }

  refreshIndexedDBImg() {
    this.localStorage
      .get('capturedPhotos', 'SwissTimeEntry')
      .then((res: any) => {
        if (!res) return;
        this.indexedDBImages = res;
      });
  }

  deleteAndSaveIntoIndexedDb(img: CaptureImageData) {
    const index = this.indexedDBImages.findIndex(
      (x) => x.fileName === img.fileName
    );
    if (index >= 0) {
      this.indexedDBImages[index] = img;
      this.localStorage.add(
        'capturedPhotos',
        this.indexedDBImages,
        'SwissTimeEntry'
      );
    }
  }

  dataURItoBlob(dataURI: string) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    var byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length);

    // create a view into the buffer
    var ia = new Uint8Array(ab);

    // set the bytes of the buffer to the correct values
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    // write the ArrayBuffer to a blob, and you're done
    var blob = new Blob([ab], { type: mimeString });
    return blob;
  }
}
